import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import Security from '../../commons/security/Security.js';

// El switch "En taller" de la grilla sigue las mismas reglas que el de "Modificar asignación" del ticket.

const ESTADOS_SIN_EDICION = ['CERRADO', 'CANCELADO'];

const esAutogestion = (ticket) => ticket.autogestion === true || Number(ticket.autogestion) === 1;

// Misma condición con la que TicketsAbm muestra la sección Asignación.
export const muestraAsignacion = (ticket) =>
	ticket.ticket_tipo !== 'GESTORIA' &&
	(!esAutogestion(ticket) || ConfigBusiness.get('mantenimientos.correctivo.autogestion.asignaGerenciador') === 'true');

export const muestraSwitchEnTaller = (ticket) =>
	Security.hasPermission('TICKETS_MODIFICAR_EN_TALLER') && muestraAsignacion(ticket);

// Sin gestión del centro de costos el ticket se abre en modo vista, donde el switch no se puede mover.
export const switchEnTallerHabilitado = (ticket, puedeEditarCC) =>
	puedeEditarCC && !ESTADOS_SIN_EDICION.includes(ticket.estado);

// 1, 2 y 3 son "en taller" (sin verificación, verificado y no verificado por GPS).
export const estaEnTaller = (ticket) => Number(ticket.en_taller) > 0;

// Solo `enTaller`: el PATCH de asignación escribe únicamente los campos que vienen en el body.
export const bodyCambioEnTaller = (enTaller) => JSON.stringify({ enTaller: enTaller });
